import { OrganizationContext } from './context';
import { OrganizationContextValue } from './types';
import { useContext } from 'react';

export const useOrganization = (): OrganizationContextValue => {
  const context = useContext(OrganizationContext);

  if (!context) {
    throw new Error('useOrganization must be used within OrganizationProvider');
  }

  return context;
};